<div fusePerfectScrollbar class="page-layout simple">
    <div class="content p-24">
        <div fxLayout="column" style="max-width: 950px;">
            <div class="row" *appIfPermission="canEditList; else cannotAccess">
                <mat-card>
                    <mat-card-header>
                        <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
                            <div>R2 Guac Servers</div>
                            <div>
                                <button type="button" mat-raised-button color="accent" aria-label="open menu"
                                        (click)="create()">
                                    Criar
                                </button>
                            </div>
                        </mat-card-title>
                    </mat-card-header>


                    <mat-card-content>
                        <app-guac-server-list *ngIf="reloadChild"></app-guac-server-list>
                    </mat-card-content>
                </mat-card>

            </div>
            <ng-template #cannotAccess>
                <div class="row">
                    <h2>
                        Sem permissão
                    </h2>
                </div>
            </ng-template>
        </div>
    </div>
</div>
